/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <Icon size={size} width={3.5}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)

/* PLUS ICON */
export const PlusIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M12 5v14M5 12h14" />
    </Icon>
)

/* EDIT ICON */
export const EditIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M11 4H7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-4" />
        <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
    </Icon>
)

/* TRASH ICON */
export const TrashIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" />
        <path d="M10 11v5M14 11v5" />
    </Icon>
)

/* SEARCH ICON */
export const SearchIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="10.8" cy="10.8" r="6.8" />
        <path d="M20.5 20.5 15.7 15.7" />
    </Icon>
)

/* LOCK ICON — NOT A SUPERADMIN, NOTHING CHANGES */
export const LockIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="4" y="11" width="16" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </Icon>
)

/* INFO ICON — THE HINT OF A SECTION */
export const InfoIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 7.6v.6" />
    </Icon>
)

/* OPERATOR ICON — THE EMPTY LIST AND THE AVATAR */
export const OperatorIcon = ({ size = 20 }) => (
    <Icon size={size}>
        <path d="M3 20V9.6a1 1 0 0 1 .5-.86l7-4.1a1 1 0 0 1 1 0l7 4.1a1 1 0 0 1 .5.86V20" />
        <path d="M2 20h20" />
        <path d="M8.5 20v-4.6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V20" />
        <path d="M11 10.5h0" />
    </Icon>
)

/* TABLE ICON — TABLES OPENED FOR THE OPERATOR */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="2.5" y="4.5" width="19" height="12" rx="4" />
        <path d="M8 20h8M12 16.5V20" />
    </Icon>
)

/* STUDIO ICON — THE GROUP OF A TABLE */
export const StudioIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4.5" width="18" height="12.5" rx="2.5" />
        <path d="M7 21h10M12 17v4" />
    </Icon>
)

/* MANAGER ICON — MANAGERS BOUND TO THE OPERATOR */
export const ManagerIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="8.2" r="3.6" />
        <path d="M5 20c0-3.6 3.1-5.6 7-5.6s7 2 7 5.6" />
    </Icon>
)

/* LINK ICON — THE INTEGRATION ENDPOINTS */
export const LinkIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M10.6 13.4a4 4 0 0 1 0-5.66l2.83-2.83a4 4 0 0 1 5.66 5.66l-1.42 1.41" />
        <path d="M13.4 10.6a4 4 0 0 1 0 5.66l-2.83 2.83a4 4 0 0 1-5.66-5.66l1.42-1.41" />
    </Icon>
)

/* KEY ICON — THE TOKEN OF AN OPERATOR */
export const KeyIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <circle cx="8" cy="15.5" r="3.5" />
        <path d="M10.5 13 20 3.5M17 3.5h3v3" />
    </Icon>
)

/* COPY ICON — THE TOKEN GOES TO THE CLIPBOARD */
export const CopyIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="9" y="9" width="11" height="11" rx="2.5" />
        <path d="M15 5.5A2.5 2.5 0 0 0 12.5 3H6.5A2.5 2.5 0 0 0 4 5.5v6A2.5 2.5 0 0 0 6.5 14" />
    </Icon>
)

/* REFRESH ICON — A NEW TOKEN OF AN OPERATOR */
export const RefreshIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M20 11a8 8 0 1 0-2.5 6.4" />
        <path d="M20 4.5V11h-6" />
    </Icon>
)

/* LICENSE ICON — THE B2C LICENSE NUMBER */
export const LicenseIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4.5" width="18" height="15" rx="3" />
        <path d="M7.5 9.5h5M7.5 13h9M7.5 16h6" />
    </Icon>
)
